module.exports = __webpack_public_path__ + "img/no-image.a45a4f1f.jpg";